export const SERVER_URL = process.env.REACT_APP_API_URL || 'http://localhost:1337'
// export const SERVER_URL = 'http://localhost:1337'

export const PATH = {
  myMonitors:'/my/monitors',
  monitors: '/monitors/',
  myProfile: '/my/profile',
  getLtdCustomersCount: '/utils/ltd_customers_count',
  monitorsAlert: '/monitors/alert',
  logout:'/auth/logout',
  monitorsId: '/monitors/{{monitorId}}',
}